export default "__VITE_ASSET__CbyZ25Zf__"